import { styled } from '@creditas/stylitas';
import { LogoHorizontalPrincipal } from '@creditas/brand-icons';

export const Navbar = styled.nav`
  display: flex;

  padding: 20px 9%;

  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: 768px) {
    padding: 10px 4%;
  }
`;

export const Logo = styled(LogoHorizontalPrincipal)`
  height: 30px;
  width: 162px;
`;
